<template>
    <v-divider v-bind="$attrs" class="primary" style="border-width: 4px 0 0"></v-divider>
</template>

<script>
export default {
    props: {},
    components: {},
    data() {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped></style>
